import React from 'react';
import classes from './CardPlaceHolder.module.css';

const CardPlaceHolder = props => {
    return (
        <>
            <div className={classes.root}>
                <div className={`${classes.rootContent} placeholder-glow`}>
                    <div className={classes.Image}>
                        <span className="placeholder" />
                    </div>
                    <div className={classes.Details}>
                        <div className={`${classes.Title} placeholder`} />
                        <div className={classes.PriceContent}>
                            <span
                                className={`${classes.OfferPrice} placeholder`}
                            />
                            <span
                                className={`${
                                    classes.OriginalPrice
                                } placeholder`}
                            />
                        </div>
                    </div>
                    <div className={classes.Actions}>
                        <div className={classes.ViewDetailsBtn}>
                            <button className={`btn btn-secondary placeholder`} />
                        </div>
                        <div className={classes.AddtoCartBtn}>
                            <button className={`btn btn-secondary placeholder`} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CardPlaceHolder;
